import { render, staticRenderFns } from "./SearchCategory.vue?vue&type=template&id=933983a8&scoped=true"
import script from "./SearchCategory.vue?vue&type=script&lang=js"
export * from "./SearchCategory.vue?vue&type=script&lang=js"
import style0 from "./SearchCategory.vue?vue&type=style&index=0&id=933983a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933983a8",
  null
  
)

export default component.exports